import { render, staticRenderFns } from "./TopKeywordEditorPopup.vue?vue&type=template&id=8e4cab52&scoped=true"
import script from "./TopKeywordEditorPopup.vue?vue&type=script&lang=js"
export * from "./TopKeywordEditorPopup.vue?vue&type=script&lang=js"
import style0 from "./TopKeywordEditorPopup.vue?vue&type=style&index=0&id=8e4cab52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4cab52",
  null
  
)

export default component.exports